import { useMemo } from 'react';
import * as React from 'react';
import { StyleSheet, View } from 'react-native';

import { UserInfo, spacing } from '@pletly/ui';

interface Props {
	name: string;
	photoUrl?: string | null;
	accessoryRight?: React.ReactNode;
}

export const Member = ({ name, photoUrl, accessoryRight }: Props) => {
	const photoSource = useMemo(() => (photoUrl ? { uri: photoUrl } : undefined), [photoUrl]);

	return (
		<View style={styles.root}>
			<UserInfo name={name} photoSource={photoSource} />

			{accessoryRight}
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: spacing(2),
	},
});
